module.exports = __webpack_public_path__ + "15edfc76869957d7b8f3792d2a5e6d2b.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/icons/tower.png
// module id = 621
// module chunks = 0